@if (combineExpandedActiveSection$ | async) {}
<a
  [pTooltip]="navigationItem().children.length === 0 ? tooltipContent : ''"
  [tooltipStyleClass]="
    navigationItem().children.length === 0 ? 'icon-btn-tooltip' : ''
  "
  class="icon-btn no-underline"
  stHoveredLeftMenu
  [menuOptions]="menuOptions"
  [ngClass]="{ 'icon-active': isActive() }"
  [menuTemplate]="canHover() ? menuContent : undefined"
  (click)="onClick()"
  [forceHide]="!canHover()"
  [routerLink]="this.navigationItem().routeUrl"
>
  <em [class]="navigationItem().iconClass"></em>
</a>
<ng-template #menuContent>
  <div class="w-full overflow-menu">
    <div
      class="menu-header flex align-items-center gap-10px text-base line-height-3 font-bold py-12px px-3 h-3rem"
    >
      <div class="body-large-bold">{{ navigationItem().name }}</div>
    </div>
    @for (item of navigationItem().children; track $index) {
      <st-menu-collapse-item
        [menuItemData]="item"
        [active]="activeChild?.id === item?.id"
      ></st-menu-collapse-item>
    }
  </div>
</ng-template>

<div class="sidebar-tooltip">
  <ng-template #tooltipContent>
    <div class="sidebar-tooltip-content">
      <span class="label-medium-medium">
        {{ navigationItem().name }}
      </span>
    </div>
  </ng-template>
</div>
